"use strict";

angular.module("vendor")
.component("catalogEntryProductAdd", {
    bindings: {
        catalogEntry: "=",
        form: "<",
        isInventoryAvailable: "<",
        isQuantityConstraintAvailable: "<",
        isPackagingQuantityAvailable: "<"
    },
    templateUrl: require("./catalog-entry-product-add.component.html"),
    controller: function($scope, Language, ProductService, PatternService) {
        $scope.INVENTORY_QUANTITY_MAX = ProductService.INVENTORY_QUANTITY_MAX;
        $scope.PRODUCT_QUANTITY_MAX = ProductService.PROCUT_QUANTITY_MAX;
        $scope.pattern = PatternService;

        Language.initializeScope($scope, null, "locale");
    }
});




//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-tab/catalog-entry-product-add.component.js
// module id = 950
// module chunks = 0